import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";

export function AdminGuard({ children }: { children: ReactNode }) {
  const { me } = useAuth();
  if (!me?.is_admin) {
    return (
      <div className="flex h-full items-center justify-center p-8 text-center">
        <div className="max-w-sm rounded-lg border border-tribal-border bg-tribal-surface p-6">
          <h2 className="text-lg font-semibold">Admin access required</h2>
          <p className="mt-2 text-sm text-tribal-muted">
            This area is restricted to HQ admins.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
